import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "components__info-item" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["href"]

import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'info-item',
  props: {
    infoItem: {
      type: Object,
      required: true,
    } 
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.infoItem.description_html)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            innerHTML: __props.infoItem.description_html
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (__props.infoItem.info_html)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass([
          { 'item--disabled': __props.infoItem.info_html.style_disabled },
          _unref(themingCssClass)('normal'),
        ]),
            target: "_blank",
            href: __props.infoItem.info_html.target
          }, _toDisplayString(__props.infoItem.info_html.label), 11, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    (__props.infoItem.mediapool_item)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("a", {
            href: __props.infoItem.mediapool_item.file_url,
            target: "_blank"
          }, _toDisplayString(__props.infoItem.mediapool_item.title), 9, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})